// Library Imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { PURGE } from 'redux-persist';

// Local Imports
import endPoints from '../../constant';
import axiosInstance from '../../http';

export interface InitialStateProps {
  allUsers?: any;
  loading?: boolean;
  error?: string | null;
}
interface UsersAPIParams {
  search?: string | null;
  type?: string | null;
  id?: string | null;
  state?: string;
}

const initialState: InitialStateProps = {
  allUsers: [],
  loading: false,
  error: null
};

// All Users API Calling
export const allUsersAPI = createAsyncThunk(
  'dashboard/users',
  async (params: UsersAPIParams, { rejectWithValue }) => {
    try {
      const { search, type, state } = params;
      let endPoint = endPoints.usersListing;
      // Search User Query
      if (search) {
        endPoint = `${endPoints.usersListing}/?search=${search}`;
      }
      // Filter User Query
      if (type) {
        endPoint = `${endPoints.usersListing}/?type=${type}`;
      }
      // STATE QUERY
      if (state) {
        endPoint = `${endPoints.usersListing}/?state=${state}`;
      }

      const { data } = await axiosInstance.get(endPoint);
      return data;
    } catch (error: any) {
      if (error?.message === 'Network Error') {
        return rejectWithValue(error?.message + '. Please check your Internet Connection!');
      } else {
        return rejectWithValue(error?.response?.data?.error?.message);
      }
    }
  }
);

// All Users API Calling
export const userDetailsAPI = createAsyncThunk(
  'dashboard/users',
  async (params: UsersAPIParams, { rejectWithValue }) => {
    try {
      let endPoint = endPoints.userDetails;

      const { data } = await axiosInstance.get(endPoint + '/' + params?.id);
      return data;
    } catch (error: any) {
      if (error?.message === 'Network Error') {
        return rejectWithValue(error?.message + '. Please check your Internet Connection!');
      } else {
        return rejectWithValue(error?.response?.data?.error?.message);
      }
    }
  }
);

// UPDAT USER PROFILE
export const updateUserProfileAPI = createAsyncThunk(
  'users/updateUserProfile',
  async (
    { formData, userId }: { formData: FormData; userId: string | undefined },
    { rejectWithValue }
  ) => {
    try {
      const { data } = await axiosInstance.put(endPoints.updateProfile + '/' + userId, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      return data;
    } catch (error: any) {
      if (error?.message === 'Network Error') {
        return rejectWithValue(error?.message + '. Please check your Internet Connection!');
      } else {
        return rejectWithValue(error?.response?.data?.error?.message);
      }
    }
  }
);

// Users Slice
export const userSlice = createSlice({
  name: 'dashboard/users',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(allUsersAPI.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(allUsersAPI.fulfilled, (state, action) => {
        state.loading = false;
        state.allUsers = action.payload;
        state.error = null;
      })
      .addCase(allUsersAPI.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(PURGE, state => {
        state.allUsers = [];
      });
  }
});

export default userSlice.reducer;
